export default __webpack_public_path__ + "static/media/30 Second Warning.f1dfed01.mp3";